import styled from 'styled-components';
import { ReactComponent as SlackIcon } from '@elementary/common-ui/assets/slack-color-small.svg';
import {
  Button,
  EmptyStateBox,
  FlexColumn,
} from '@elementary/common-ui/components';
import { Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';

const Wrapper = styled(FlexColumn)`
  height: 100%;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const ButtonStyled = styled(Button)`
  margin-top: 8px;
`;

const CodeBlock = styled(Typography)`
  display: inline;
  background: ${({ theme }) => theme.palette.common.gray5};
  border-radius: 2px;
  padding: 2px 5px;
`;

const ReportEmptyStatePage = () => {
  const { pathname } = useLocation();

  const command = pathname.includes('/model-runs') ? 'dbt run' : 'dbt test';

  const title = pathname.includes('/model-runs')
    ? 'No model runs'
    : 'No test results';

  return (
    <Wrapper>
      <EmptyStateBox title={title}>
        Try running <CodeBlock>{command}</CodeBlock> and generate a new report
        <br />
        <br />
        Still empty? Check out our{' '}
        <EmptyStateBox.Link
          href="https://docs.elementary-data.com/general/troubleshooting"
          target="_blank"
        >
          troubleshooting doc
        </EmptyStateBox.Link>{' '}
        or reach out to us
        <br />
        we are always happy to help!
      </EmptyStateBox>

      <ButtonStyled
        variant="outlined"
        color="secondary"
        endIcon={<SlackIcon />}
        onClick={() =>
          window.open(
            'https://join.slack.com/t/elementary-community/shared_invite/zt-uehfrq2f-zXeVTtXrjYRbdE_V6xq4Rg',
          )
        }
      >
        Support on Slack
      </ButtonStyled>
    </Wrapper>
  );
};

export default ReportEmptyStatePage;
